import { render, staticRenderFns } from "./HeaderAdm.vue?vue&type=template&id=938ccfe2&scoped=true"
import script from "./HeaderAdm.vue?vue&type=script&lang=js"
export * from "./HeaderAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938ccfe2",
  null
  
)

export default component.exports